import {_base64_str_encoder} from './_base64_str_encoder.jsy'
import {_base64_str_decoder} from './_base64_decoder.jsy'
import {_b64_lut} from './_base64_lut.jsy'


export function base64_str_encoder(encode) ::
  if ! encode?.length ::
    encode = _b64_lut(encode).enc_sz
  return _base64_str_encoder(encode)

export function base64_str_decoder(decode) ::
  if ! decode?.length ::
    decode = _b64_lut(decode).dec
  return _base64_str_decoder(decode)


export const u8_to_base64 = u8 => base64_str_encoder(false)(u8)
export const base64_to_u8 = b64 => base64_str_decoder(false)(b64)

export const u8_to_base64url = u8 => base64_str_encoder(true)(u8)
export const base64url_to_u8 = b64u8 => base64_str_decoder(true)(b64u8)
